/**
 * Created by Teo on 23/08/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('communicationStatuses', {
                parent: 'masterData',
                url: '/communicationStatuses',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/communicationStatuses/communicationStatuses.html',
                        controller: 'MDCommunicationStatusesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
